import { Component, OnInit, ViewChild} from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

declare var document: any;
let darkMode: boolean;
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;

  // status: boolean = false;
  // clickEvent(){
  //     this.status = !this.status;
  // }







  darkMode: boolean;
  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  tab : any = 'tab1';
  tab1 : any
  tab2 : any
  tab3 : any
  tab4 : any
  Clicked : boolean



  constructor() { }

  ngOnInit(): void {
    this.darkMode = darkMode;
  }


  onClick(check){
    //    console.log(check);

        if(check==1){
          this.tab = 'tab1';
        }else if(check==2){
          this.tab = 'tab2';
        }else if(check==3){
          this.tab = 'tab3';
        }else{
          this.tab = 'tab4';
        }

    }

  changeMode = () => {
    this.darkMode = !this.darkMode;
    darkMode = this.darkMode;
    let $body: any = document.getElementById('mybody1');
    $body.classList[this.darkMode ? 'add' : 'remove']("At-BlackTheme")
    console.log($body)
  }

}
